import { render } from "./SubNave.vue?vue&type=template&id=4af1ab50&scoped=true"
import script from "./SubNave.vue?vue&type=script&lang=js"
export * from "./SubNave.vue?vue&type=script&lang=js"

import "./SubNave.vue?vue&type=style&index=0&id=4af1ab50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af1ab50"]])

export default __exports__